import { render } from "./CustomerMainTable.vue?vue&type=template&id=94a2fc30"
import script from "./CustomerMainTable.vue?vue&type=script&lang=js"
export * from "./CustomerMainTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__